"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMetricsBuffer = void 0;
const constants_1 = require("./constants");
function isMetricValid(metric) {
    const currentTimeStamp = new Date().getTime();
    const timeDifference = currentTimeStamp - metric.timestamp;
    const isExpired = timeDifference >= constants_1.FIFTY_FIVE_MINUTES;
    const isInTheFuture = -timeDifference >= constants_1.FIVE_MINUTES;
    return !isExpired && !isInTheFuture;
}
function makeMetricsBuffer(bufferSize) {
    let buffer = [];
    return {
        add(metric) {
            buffer.push(metric);
        },
        flush() {
            buffer = [];
        },
        values() {
            return buffer.slice();
        },
        isEmpty() {
            return buffer.length === 0;
        },
        isFull() {
            return buffer.length >= bufferSize;
        },
        prune() {
            buffer = buffer.filter(isMetricValid);
        },
    };
}
exports.makeMetricsBuffer = makeMetricsBuffer;
//# sourceMappingURL=metrics-buffer.js.map